import React, {useState} from "react";
import {EmployeeDetails} from "@/data/entities/employee";
import {SetStateFn} from "@/utils/SetStateUtils";
import {ConfirmModal, useNotifications} from "peggirkit";
import {FormattedMessage, useIntl} from "react-intl";
import {useMutation} from "@tanstack/react-query";
import {notifyDanger, notifySuccess} from "@/utils/NotifyUtils";
import {useNavigate} from "react-router-dom";
import router from "@/routing/Router";
import {api} from "@/data/api";

type Props = {
    employee: EmployeeDetails,
    showDeleteModal: boolean,
    setShowDeleteModal: SetStateFn<boolean>,
};

const DeleteEmployeeModal = ({employee, showDeleteModal, setShowDeleteModal}: Props) => {
    const intl = useIntl();
    const navigate = useNavigate();
    const {notify} = useNotifications();
    const [loading, setLoading] = useState(false);
    const {mutate} = useMutation({
        mutationFn: (employeeId: number) => api.employee.deleteEmployee(employeeId),
        onSuccess: () => {
            notifySuccess(intl.formatMessage({id: "employeeDeleted"}), notify);
            navigate(router.employees.absolutePath());
        },
        onError: () => {
            notifyDanger(intl.formatMessage({id: "systemError"}), notify);
            setLoading(false);
        },
    });

    return (
        <ConfirmModal
            type={"danger"}
            show={showDeleteModal}
            onClose={() => setShowDeleteModal(false)}
            title={intl.formatMessage({id: "deleteEmployee"})}
            dismissButton={{
                text: intl.formatMessage({id: "cancel"}),
            }}
            continueButton={{
                text: intl.formatMessage({id: "continue"}),
                onClick: () => {
                    setLoading(true);
                    mutate(employee.id)
                },
                props: {color: "danger"},
            }}
            disabled={loading}
            loading={loading}
            position={"center-bottom"}
            breakpoints={{md: {position: "center"}}}
        >
            <FormattedMessage id={"confirmDeleteEmployee"}/>
        </ConfirmModal>
    );
};

export default DeleteEmployeeModal;